<template>
  <div :class="b()">
    <div :class="b('list')">
      <e-loading-indicator
        v-if="productStore.runningRequests.apiFetchProductSetsAndKits"
        :class="b('loader')"
        size="medium"
        fullwidth
      />

      <c-product-set
        v-for="item in items"
        :key="`set-${isApiFetchModeActive}-${item.set.name}`"
        :product-set-config="item"
        :highlight-id="productId"
      />
    </div>
    <c-pagination
      v-if="listPagination.moreThanOnePage()"
      :pagination="listPagination"
      @change="onPaginationChanged"
    />
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import useProductStore from '@/stores/product';
  import cPagination from '@/components/c-pagination.vue';
  import cProductSet from '@/components/c-product-set.vue';
  import eLoadingIndicator from '@/elements/e-loading-indicator.vue';
  import { Pagination } from '@/helpers/pagination';
  import { ProductSet } from '@/types/product';

  type Setup = {
    productStore: ReturnType<typeof useProductStore>;
  };

  type Data = {
    isApiFetchModeActive: boolean;
    apiList: ProductSet[];
    listPagination: Pagination;
  };

  /**
   * Renders a list of sets and kits which fetches new sets from the API.
   */
  export default defineComponent({
    name: 'c-product-set-list',
    components: {
      eLoadingIndicator,
      cPagination,
      cProductSet,
    },

    props: {
      /**
       * The product id on which basis sets and kits should be fetched.
       */
      productId: {
        type: Number,
        required: true,
      },

      /**
       * The initial list to display.
       */
      initialList: {
        type: Array as PropType<ProductSet[]>,
        required: true,
      },

      /**
       * The pagination.
       */
      pagination: {
        type: Object as PropType<Pagination>,
        required: true,
      },
    },
    // emits: [],

    setup(): Setup {
      return {
        productStore: useProductStore(),
      };
    },
    data(): Data {
      return {
        isApiFetchModeActive: false,
        apiList: [],
        listPagination: new Pagination(),
      };
    },

    computed: {
      items(): ProductSet[] {
        return this.isApiFetchModeActive ? this.apiList : this.initialList;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      const { pagination } = this;

      this.listPagination.update(pagination);
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      onPaginationChanged(page: number) {
        this.listPagination.update({ current: page });

        this.productStore.apiFetchProductSetsAndKits(this.productId, this.listPagination).then((response) => {
          this.apiList = response.data;
          this.isApiFetchModeActive = true;
          this.listPagination.update(response.pagination);
        });
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  .c-product-set-list {
    display: flex;
    flex-direction: column;
    gap: 3rem;

    &__list {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
  }
</style>
